//#region IMPORT
import React, { useEffect, useRef, useState } from 'react';
import M_TRA_BASIC from './M_TRA_BASIC';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import Global from './../../../../../Services/Common/Global';
import Commons from './../../../../../Services/Common/Common';
import { showSnackbar } from '../../../../../Reducer/SnackbarReducer';
import { CommonActions } from '../../../../../Reducer/CommonReducer';
import { NavBarInfoActions } from '../../../../../Reducer/NavBarInfoReducer';
import { useAppNavigate } from '../../../../../Hooks/back/useAppNavigate';
//#endregion

export default function M_TRA_BASICF() {
  //#regino 변수
  const { navigate } = useAppNavigate();
  const [loading, setLoading] = useState(false);
  const { userInfo, lanInfo } = useSelector((state) => state.BaseInfo);

  const dispatch = useDispatch();
  const [rowData1, setRowData1] = useState([]);
  const [searchClick, setSearchClick] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const [selectedChip, setSelectedChip] = useState({
    label: '전체',
    value: '',
  });

  const searchRef = useRef({
    custList: [],
    custCd: '',
    depName: '',
    searchText: '',
  });
  //#endregion

  useEffect(() => {
    Init();
  }, []);

  useEffect(() => {
    if (userInfo?.ID) {
      if (searchClick) {
        SearchLogic1(userInfo);
      } else {
        searchRef.current.searchText = '';
        SearchLogic1(userInfo);
      }
    }
  }, [searchClick, userInfo]);

  const Init = async () => {
    setLoading(true);
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('교육 자료'));

    try {
      await SearchCust();
      await SearchLogic1();

      dispatch(CommonActions.setActiveStep(0));
    } catch (e) {
      console.log('Error: ', e);
    } finally {
      setLoading(false);
    }
  };

  //#region 조회
  //사업장정보 조회(userInfo:사용자정보)
  const SearchCust = async () => {
    setLoading(true);
    try {
      const result = await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_GET_AUTH_CUST_MANAGER',
            _USER_ID: userInfo.userid, // 사용자 ID
            _AUTH_CD: Commons.EncryptAES(userInfo.authCd) || '', // 권한코드
          },
        ]
      );
      let data = result.data;
      let changeData = [];

      if (data.length === 0) {
        searchRef.current = {
          ...searchRef.current,
          custList: [],
          custCd: '',
        };
      } else if (data[0]?.type === 'Error') {
        //Get할 땐 에러인 경우 인덱스 0 에 {type:"Error"} 로 반환되고, 에러가 아닐 경우엔 정상적인 데이터 반환
        dispatch(showSnackbar({ message: data[0].message, type: 'error' }));
        return false;
      } else {
        data.forEach((_item) => {
          changeData.push({
            value: _item.custCd,
            name: _item.custNm,
          });
        });
        setSelectedChip(changeData[0]);
        searchRef.current = {
          ...searchRef.current,
          custList: changeData,
          custCd: changeData[0].value,
        };
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  //조회조건 부서 조회
  const SearchLogic1 = async (onComplete) => {
    // ResetLogicAll();
    setLoading(true);
    try {
      // 시스템 계정일 경우 회사 검색조건으로 검색
      const coCd =
        userInfo.authCd === 'ADMIN' ? searchRef.current.coCd : userInfo.coCd;

      const result = await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Execute.execute,
        [
          {
            procedureName: 'SP_TRA_BASIC_04_R1',
            _USER_ID: userInfo.userid || '', //로그인한 user 사업장코드
            _AUTH_CD: Commons.EncryptAES(userInfo.authCd) || '', //권한코드
            _CO_CD: Commons.EncryptAES(coCd) || '', //회사코드
            _CUST_CD: Commons.EncryptAES(searchRef.current.custCd) || '', //사업장코드
            _searchText: Commons.EncryptAES(searchRef.current.searchText) || '', //검색창
          },
        ]
      );
      let data = result.data;

      if (data.length === 0) {
        setRowData1([]);
      } else if (data[0]?.type === 'Error') {
        //Get할 땐 에러인 경우 인덱스 0 에 {type:"Error"} 로 반환되고, 에러가 아닐 경우엔 정상적인 데이터 반환
        dispatch(showSnackbar({ message: data[0].message, type: 'error' }));

        return false;
      } else {
        setRowData1(Commons.InsertNumber(data));
        if (typeof onComplete === 'function') {
          onComplete(data);
        }
      }
    } catch (e) {
      console.log(e);
      dispatch(showSnackbar({ message: e.message, type: 'error' }));
    } finally {
      setLoading(false);
    }
  };
  //#endregion

  //#region 나머지 함수
  const HandleWriteClick = () => {
    navigate('/M_TrainingPage/write');
  };
  //#endregion

  return (
    <div className="wrap">
      <M_TRA_BASIC
        userInfo={userInfo}
        rowData1={rowData1}
        searchClick={searchClick}
        setSearchClick={setSearchClick}
        searchInput={searchInput}
        setSearchInput={setSearchInput}
        selectedChip={selectedChip}
        setSelectedChip={setSelectedChip}
        searchRef={searchRef}
        // 함수
        SearchLogic1={SearchLogic1}
        HandleWriteClick={HandleWriteClick}
      />
    </div>
  );
}
